import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { param: { type: String, default: "platform" } };
  static targets = ["link"];

  connect() {
    const platform = this.detectPlatform();

    const href = this.hasLinkTarget ? this.linkTarget.getAttribute("href") : "(no link target)";

        const u = new URL(href, window.location.origin);
        u.searchParams.set(this.paramValue, platform);
        this.linkTarget.setAttribute("href", u.pathname + u.search + u.hash);
  }


  detectPlatform() {
    const ua = navigator.userAgent.toLowerCase();
    if (/android/.test(ua)) return "android";
    if (/iphone|ipad|ipod/.test(ua)) return "ios";
    return "web";
  }
}
